export const PRODUCTS_ARE_LOADING = 'PRODUCTS_ARE_LOADING'
export const PRODUCTS_LOADED = 'PRODUCTS_LOADED'
export const PRODUCTS_FAILED = 'PRODUCTS_FAILED'
export const SETS_LOADED = 'SETS_LOADED'

export const START_RESIZING_PRODUCT = 'START_RESIZING_PRODUCT'
export const FINISH_RESIZING_PRODUCT = 'FINISH_RESIZING_PRODUCT'



// WEBPACK FOOTER //
// ./src/constants/productsActions.js